import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, CardMedia, Stack, Typography } from '@mui/material'
import React from 'react'
import { SystemConfigurationComponentsResponse } from 'src/Libs/shop/models'
import { makeStyles } from 'tss-react/mui'
import { getImageUrlBySize } from 'src/Libs/shop/utils'
import { ShopImageThumnbailSizes } from 'src/Libs/shop/types'
import { Component } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'

interface MainComponentSystemConfigurationCardProps {
  mainComponent: SystemConfigurationComponentsResponse | null
  selectedMainComponents: Component[] | null
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '8px',
    marginTop: theme.spacing(2),
  },
}))

const MainComponentSystemConfigurationCard: React.FC<MainComponentSystemConfigurationCardProps> = ({ mainComponent, selectedMainComponents }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const mandatoryCategories = mainComponent?.components.filter(category => category.mandatory) ?? []
  const selectedProducts = selectedMainComponents?.flatMap(component => component.products) ?? []

  const hasSelectedMandatoryProducts = mandatoryCategories.some(category =>
    category.products.some(productWrapper => selectedProducts.some(selectedProduct => selectedProduct.id === productWrapper.product.id))
  )

  return (
    <Stack spacing={2}>
      {mandatoryCategories.map(category => {
        const selectedProductsForCategory = category.products.filter(productWrapper =>
          selectedProducts.some(selectedProduct => selectedProduct.id === productWrapper.product.id)
        )

        if (selectedProductsForCategory.length === 0) {
          return null
        }

        return (
          <Box key={category.id}>
            <Typography variant="h5" mb={2}>
              {category.translated.name}
            </Typography>

            {selectedProductsForCategory.map(productWrapper => {
              const productImageUrl = getImageUrlBySize(productWrapper.product?.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)

              return (
                <Box key={productWrapper.product.id} className={classes.mainComponentWrapper}>
                  <CardMedia component="img" image={productImageUrl} sx={{ maxWidth: '45px', height: 'auto' }} />
                  <Typography variant="h4">{productWrapper.product.translated.name}</Typography>
                </Box>
              )
            })}
          </Box>
        )
      })}

      {(mandatoryCategories.length === 0 || !hasSelectedMandatoryProducts) && (
        <Typography variant="h4">{t('shop.system-configure-card.not-selected-yet')}</Typography>
      )}
    </Stack>
  )
}

export default MainComponentSystemConfigurationCard
